import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'front-end-fund-cash-purchase-confirm-draft',
  templateUrl: './fund-cash-purchase-confirm-draft.component.html',
  styleUrls: ['./fund-cash-purchase-confirm-draft.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashPurchaseConfirmDraftPage {
  constructor(
    private modalController: ModalController,
    private router: Router
  ) {}

  close() {
    this.modalController.dismiss();
    this.router.navigateByUrl('/home/fund-cash/draft');
  }
}
